import { mergeCells } from 'prosemirror-tables';
import { Extension } from '@tiptap/core';

export const MergeTableCells = Extension.create({
  name: 'mergeTableCells',

  addCommands() {
    return {
      mergeTableCells: () => ({ state, dispatch }) => {
        const { selection } = state;
        if (mergeCells(state, dispatch)) {
          console.log('Cells merged');
          return true;
        }
        return false;
      },
    };
  },
});
